import React from 'react'
import { translateMetaCategoriesSource } from 'utils/translation_sources'

// components
import CheckboxWithLabel from 'components/CleanUIComponents/Checkbox/CheckboxWithLabel'

// hoc
import withGlotio from 'hoc/withGlotio';

// utils
import { getFinalSegment } from 'utils/Utils';
import { fallBackTranslation } from 'utils/fallbackTranslation';

// constants
import { CURRENT_PROJECT_STORAGE_KEY } from 'constants/session_storage_keys.contants';
import { PLATFORMS } from 'constants/platforms.contants';

// styles
import styles from './index.module.scss';

const DefintionBlock = props => {
  const {
    definition,
    disabledFields,
    handleCheckboxChange,
    translateText,
    formatNumber,
    extraMargin = false,
  } = props

  const { num_chars, meta_source } = definition
  const { platform = PLATFORMS.PRESTASHOP } = JSON.parse(sessionStorage.getItem(CURRENT_PROJECT_STORAGE_KEY)) || {}

  const getFieldCharsNumber = (chars, isDisabled = false, type = null) => {
    if (type === 'elementor' && chars === 0) {
      return (
        <>
          ({translateText('Activate and launch a process to calculate characters')})
        </>
      )
    }
    return (
      <>
        ({translateText('{chars} characters', { chars: formatNumber(chars) })})
        { isDisabled &&
          <>
            &nbsp;
            <span className={styles.not_supported}>{translateText('Not supported')}</span>
          </>
        }
      </>
    )
  }

  const getBlockName = () => {
    if (!meta_source) return null
    return <>{ translateMetaCategoriesSource(meta_source, ' > ', platform) }</>
  }

  const renderDefinitionHeader = () => {
    const { fields } = definition
    const { type } = fields.find(f => f.type === 'elementor') || {}
    return (
      <div className={styles.definition_header}>
        <span className={styles.definition_title}>
          {getBlockName()}
        </span>
        <span className={styles.definition_title_info}>
          {getFieldCharsNumber(num_chars, false, type)}
        </span>
      </div>
    )
  }

  const classNameForExtraMargin = extraMargin ? styles.extra_margin : ''

  return (
    <div>
      <div>
        {renderDefinitionHeader()}
      </div>
      <div className={`${styles.definition_wrapper} ${classNameForExtraMargin}`}>
        <FieldsByDefinition
          definition={definition}
          translateText={translateText}
          disabledFields={disabledFields}
          handleCheckboxChange={handleCheckboxChange}
          formatNumber={formatNumber}
        />
      </div>
    </div>
  )
}

export const FieldsByDefinition = ({ definition, translateText, disabledFields, handleCheckboxChange, formatNumber }) => {
  const { translatable, fields, meta_source, _id: definitionId } = definition
  const wildcardTemplateTranslation = ['theme', 'module', 'theme_module', 'mail', 'theme_email', 'module_email', 'theme_module_email'];

  const getWildcardTranslation = (type) => {
    if (wildcardTemplateTranslation.includes(type)) {
      return translateText('templates')
    }

    return translateText('other_fields')
  }

  const getFieldCharsNumber = (chars, isDisabled = false, type = null) => {
    if (type === 'elementor' && chars === 0) {
      return (
        <>
          ({translateText('Activate and launch a process to calculate characters')})
        </>
      )
    }
    return (
      <>
        ({translateText('{chars} characters', { chars: formatNumber(chars) })})
        { isDisabled &&
          <>
            &nbsp;
            <span className={styles.not_supported}>{translateText('Not supported')}</span>
          </>
        }
      </>
    )
  }

  const isTranslatableField = (field) => {
    return translatable && field.translatable
  }

  const isActiveField = field => {
    return isTranslatableField(field) && !disabledFields.includes(field.field)
  }

  const getFieldName = (field) => {
    if (field.type === 'elementor') {
      return 'platform.fields.elementor'
    }

    return `platform.fields.${ field.field === '*' ? getWildcardTranslation(meta_source.type) : field.field }`
  }

  return fields.map(field => {
    const fieldName = getFieldName(field)
    const isTranslatable = isTranslatableField(field)
    const fieldText = fallBackTranslation(translateText(fieldName), fieldName, getFinalSegment)

    return (
      <div key={field.field}>
        <CheckboxWithLabel
          value={`${definitionId}-${field.field}`}
          title={fieldText}
          subtitle={getFieldCharsNumber(field.num_chars, !isTranslatable, field.type)}
          isChecked={isActiveField(field)}
          isDisabled={!isTranslatable}
          onChange={checked => handleCheckboxChange({ value: field.field, checked, key: definitionId })}
          fluid
          activeBorderHoverEffect={false}
        />
      </div>
    )
  })
}

export default withGlotio(DefintionBlock)
